import { MessageSquare, Mic, X } from 'lucide-react'
import { adjustBrightness } from '../utils/color'

interface VoiceBotHeaderProps {
  botName: string
  companyName: string
  primaryColor: string
  isUploading: boolean
  onClose: () => void
  /** Optional: when provided, renders a "switch to chat" icon button
   *  next to Close. Symmetric with ChatModePanel's "Switch to voice"
   *  button. The parent (AssistantShell) wires this to the channel
   *  state machine so unmount→remount handles voice teardown cleanly. */
  onSwitchToChat?: () => void
  switchToChatLabel?: string
}

/**
 * Wave 7d: Top header bar of the voice bot panel.
 * Brand mic icon + bot/company name on the left, close button on the right.
 * Close is disabled while audio is uploading.
 */
export const VoiceBotHeader = (props: VoiceBotHeaderProps) => {
  const { botName, companyName, primaryColor, isUploading, onClose, onSwitchToChat, switchToChatLabel } = props

  return (
    <div
      style={{
        background: `linear-gradient(135deg, ${primaryColor}, ${adjustBrightness(primaryColor, 0.8)})`,
        padding: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        color: 'white',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <Mic size={24} />
        <div>
          <h2 style={{ margin: 0, fontSize: 18, fontWeight: 600 }}>{botName}</h2>
          <p style={{ margin: 0, fontSize: 12, opacity: 0.9 }}>{companyName}</p>
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {onSwitchToChat && (
          <button
            type="button"
            onClick={onSwitchToChat}
            disabled={isUploading}
            title={switchToChatLabel || 'Switch to chat'}
            aria-label={switchToChatLabel || 'Switch to chat'}
            style={{
              background: 'rgba(255,255,255,0.2)',
              border: 'none',
              borderRadius: 8,
              padding: 8,
              cursor: isUploading ? 'not-allowed' : 'pointer',
              color: 'white',
              opacity: isUploading ? 0.5 : 1,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <MessageSquare size={18} />
          </button>
        )}
        <button
          type="button"
          onClick={onClose}
          disabled={isUploading}
          style={{
            background: 'rgba(255,255,255,0.2)',
            border: 'none',
            borderRadius: 8,
            padding: 8,
            cursor: isUploading ? 'not-allowed' : 'pointer',
            color: 'white',
            opacity: isUploading ? 0.5 : 1,
          }}
        >
          <X size={18} />
        </button>
      </div>
    </div>
  )
}
